import {
  entitiesBatch,
  postCompanyMap,
  updateCompanyMap,
  companiesSnapshots,
  ADD_COMPANY_TO_IMPORT,
  POST_CONNECTED_COMPANIES,
  CLEAR_COMPANIES_LIST_IMPORT,
  ADD_COMPANIES_LIST_TO_IMPORT,
  REMOVE_COMPANY_FROM_IMPORT,
} from './types';

export const requestFetchEntitiesBatch = (batchId) => ({
  type: entitiesBatch.request,
  batchId,
});

export const requestFetchEntitiesBatchSuccess = (batchId, response) => ({
  type: entitiesBatch.success,
  batchId,
  response,
});

export const requestFetchEntitiesBatchFailure = (error) => ({
  type: entitiesBatch.failure,
  error,
});

export const requestPostEntitiesBatch = (filePayload, promise) => ({
  type: entitiesBatch.request,
  filePayload,
  promise,
});

export const requestPostEntitiesBatchSuccess = ({ id, companyMap }) => ({
  type: entitiesBatch.success,
  batchId: id,
  companyMap,
});

export const requestPostEntitiesBatchFailure = (error) => ({
  type: entitiesBatch.failure,
  error,
});

export const requestGetCompaniesSnapshots = (batchId, promise) => ({
  type: companiesSnapshots.request,
  batchId,
  promise,
});

export const requestGetCompaniesSnapshotsSuccess = ({ snapshots }) => ({
  type: companiesSnapshots.success,
  snapshots,
});

export const requestGetCompaniesSnapshotsFailure = (error) => ({
  type: companiesSnapshots.failure,
  error,
});

export const requestUpdateCompanyMap = (batchId, companyMap, promise) => ({
  type: updateCompanyMap.request,
  batchId,
  companyMap,
  promise,
});

export const requestPostCompanyMap = (batchId, promise) => ({
  type: postCompanyMap.request,
  batchId,
  promise,
});

export const requestPostCompanyMapSuccess = (progressData) => ({
  type: postCompanyMap.success,
  progressData,
});

export const requestPostCompanyMapFailure = (error) => ({
  type: postCompanyMap.failure,
  error,
});

export const requestPostConnectedCompanies = (batchId, connectedCompanies, promise) => ({
  type: POST_CONNECTED_COMPANIES,
  batchId,
  connectedCompanies,
  promise,
});

export const requestUpdateCompanyMapSuccess = ({ companyMap }) => ({
  type: updateCompanyMap.success,
  companyMap,
});

export const requestUpdateCompanyMapFailure = (error) => ({
  type: updateCompanyMap.failure,
  error,
});

export const addCompanyToImport = (companyNumber) => ({
  type: ADD_COMPANY_TO_IMPORT,
  companyNumber,
});

export const removeCompanyFromImport = (companyNumber) => ({
  type: REMOVE_COMPANY_FROM_IMPORT,
  companyNumber,
});

export const clearCompaniesListImport = (companiesNumbers) => ({
  type: CLEAR_COMPANIES_LIST_IMPORT,
  companiesNumbers,
});

export const addCompaniesListToImport = (companiesNumbers) => ({
  type: ADD_COMPANIES_LIST_TO_IMPORT,
  companiesNumbers,
});
